<template>
  <div style="position: sticky !important;">
    <div class="d-flex align-center justify-center">
      <v-btn block class="mb-2" v-on:click="selected = []">
        ИЗМЕНИТЬ УЧАСТОК
      </v-btn>
    </div>
    <div class="clock" style="position: relative">
      {{ this.time.toLocaleTimeString() }}
      <div class="d-flex align-center" style="position: absolute; bottom: 30px; font-size: 18px !important; text-align: center" v-if="this.update_time">
        <div class="clock-small d-flex justify-center align-center">
          <div style="padding: 5px">
            <span style="font-size: 10px">ОБНОВЛЕНО</span><br>
            {{ this.update_time.toLocaleTimeString() }}
          </div>
        </div>
      </div>
      <div style="position: absolute; top: 30px; font-size: 18px !important; width: 77%; text-align: center" v-if="this.update_time">
        <v-chip density="compact" class="ma-2" v-for="filter in filters.filter(el => selected.includes(el.guid))" :key="filter">{{ filter.name.replace('Производственный участок в', '') }}</v-chip>
      </div>
    </div>
    <IconLegend />
    <v-divider />
    <ColorLegend />
  </div>
</template>

<script>
import IconLegend from "@/components/Dashboard/Legends/IconLegend.vue";
import ColorLegend from "@/components/Dashboard/Legends/ColorLegend.vue";
import {FiltersSelStore, FiltersStore, UpdateTimeStore} from "@/store/Dashboard/TVApp";

export default {
  name: "C_Widgets",
  components: {ColorLegend, IconLegend},
  computed: {
    update_time: {
      get() {
        return UpdateTimeStore().get()
      },
      set(value) {
        UpdateTimeStore().set(value)
      }
    },
    selected: {
      get() {
        return FiltersSelStore().get()
      },
      set(value) {
        FiltersSelStore().set(value)
      }
    },
    filters: {
      get() {
        return FiltersStore().get()
      },
      set(value) {
        FiltersStore().set(value)
      }
    }
  },
  beforeMount() {
    setInterval(() => {
      this.time = new Date()
    }, 1000)
  },
  data() {
    return {
      time: new Date()
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'LCD';
  src: url('@/assets/fonts/lcd.ttf');
}

.clock {
  flex-wrap: wrap;
  width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed rgba(0,0,0,0.1);
  box-shadow: inset 0px 0px 15px rgba(0,0,0,0.05);
  background-color: #ffffff;
  border-radius: 1000px;
  font-family: 'LCD' !important;
  font-size: 100px;
}

.clock-small {
  flex-wrap: wrap;
  aspect-ratio: 1 / 1;
  width: fit-content;
  border: 1px dashed rgba(0,0,0,0.1);
  box-shadow: inset 0px 0px 15px rgba(0,0,0,0.05);
  background-color: #ffffff;
  border-radius: 1000px;
}

</style>